module.exports = __webpack_public_path__ + "static/media/ID_PC.ce011bd3.png";